$(document).ready(function() {
    
    if (typeof compare !== 'undefined') {
        products_to_compare.forEach(function(modelId) {
            let matchingProduct = compare_products.find(function(product) {
                return product.id == modelId;
            });

            if (matchingProduct) {
                compare.push(matchingProduct);
            }
        });
    
        getCompare();
    }

    let newScroll = $('.product-comparison .new-scroll');
    newScroll.find('.scroll-progress').width($('.product-comparison .col-custom:nth-child(2)').innerWidth()*4);

    if ($('.tech-specs').length) {
        $('.tech-specs .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1250: {
                        items: 3
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
            $(this).trigger('refresh.owl.carousel');
        });
    }
    
});

$(window).resize(function() {
    let newScroll = $('.product-comparison .new-scroll');
    newScroll.find('.scroll-progress').width($('.product-comparison .col-custom:nth-child(2)').innerWidth()*4);
});

function getCompare() {

    let idx = 0;
    compare.forEach(product => {
        $(`.compare .data--overview:eq(${idx})`).html(product.overview);
        $(`.compare .data--oled_screen:eq(${idx})`).html(product.oled_screen);
        $(`.compare .data--fov:eq(${idx})`).html(product.fov);
        $(`.compare .data--display_size:eq(${idx})`).html(product.display_size);
        $(`.compare .data--refresh_rate:eq(${idx})`).html(product.refresh_rate);
        $(`.compare .data--eyebox:eq(${idx})`).html(product.eyebox);
        $(`.compare .data--ppd:eq(${idx})`).html(product.ppd);
        $(`.compare .data--to_eye_brightness:eq(${idx})`).html(product.to_eye_brightness);
        $(`.compare .data--gamma:eq(${idx})`).html(product.gamma);
        $(`.compare .data--color_temperature:eq(${idx})`).html(product.color_temperature);
        $(`.compare .data--color_space:eq(${idx})`).html(product.color_space);
        $(`.compare .data--color_contrast:eq(${idx})`).html(product.color_contrast);
        $(`.compare .data--color_mode:eq(${idx})`).html(product.color_mode);
        $(`.compare .data--speaker:eq(${idx})`).html(product.speaker);
        $(`.compare .data--audio_mode:eq(${idx})`).html(product.audio_mode);
        $(`.compare .data--eye_protection:eq(${idx})`).html(product.eye_protection);
        $(`.compare .data--authentication:eq(${idx})`).html(product.authentication);
        $(`.compare .data--color_accuracy:eq(${idx})`).html(product.color_accuracy);
        $(`.compare .data--ppi:eq(${idx})`).html(product.ppi);
        $(`.compare .data--wearing_adjustment:eq(${idx})`).html(product.wearing_adjustment);
        $(`.compare .data--weight:eq(${idx})`).html(product.weight);

        idx++;
    });
}

$('.product-comparison').each(function() {
    let $comp = $(this);
    let hozSyncing = false;

    $comp.find('.hozscroll').on('scroll', function() {
        if (!hozSyncing) {
            hozSyncing = true;
            $comp.find('.new-scroll')
                .scrollTop($(this).scrollTop())
                .scrollLeft($(this).scrollLeft());
            hozSyncing = false;
        }
    });

    $comp.find('.new-scroll').on('scroll', function() {
        if (!hozSyncing) {
            hozSyncing = true;
            $comp.find('.hozscroll')
                .scrollTop($(this).scrollTop())
                .scrollLeft($(this).scrollLeft());
            hozSyncing = false;
        }
    });
});

$('.tech-specs .toggles .toggle').on('click', function() {
    let cat = $(this).data('cat');

    $(this).addClass('active').siblings().removeClass('active');

    $(`.tech-specs .category[data-cat="${cat}"]`).addClass('active').siblings().removeClass('active');
});